import * as app from './app'
import * as game from './game'
import * as overlay from './overlay'
import * as system from './system'

const handlers = {
  ...app,
  ...game,
  ...system,
  ...overlay,
}

export default handlers
